'use strict';

let Marionette = require('backbone.marionette');

export default Marionette.View.extend({

  className: 'location-details',
  template: require('./templates/details.hbs'),

  initialize: function (options) {
    this.latitude = options.latitude;
    this.longitude = options.longitude;
    this.waitTime = options.waitTimes.get(this.model.id);
    this.shouldShowWaitTime = options.shouldShowWaitTime;
  },

  serializeData: function () {
    let json = this.model.toJSON();
    json.showWaitTime = this.shouldShowWaitTime && this.model.shouldShowWaitTime();

    if (json.showWaitTime && this.waitTime) {
      json.waitTime = this.waitTime.get('waitTime');
    }

    if (!json.virtual && this.hasCoordinates()) {
      let distanceInKm = this.model.distanceFromPoint(this.latitude, this.longitude).toFixed(1);
      let distanceInMiles = (distanceInKm / 1.609344).toFixed(1);
      json.distance = distanceInKm + 'km / ' + distanceInMiles + 'mi';
    }

    return json;
  },

  hasCoordinates: function () {
    return this.latitude !== null && this.longitude !== null;
  },
});
